/**
 * Camera profile (GDD §3.2): 'Desktop and tablet landscape' vs 'Phone and tablet portrait'. Phones held sideways
 * are not in the table; the profile follows the screen's shape (landscape when width ≥ height, master plan §11).
 */
import { config, type CameraProfile } from '../core/config.ts';

export type ProfileName = 'landscape' | 'portrait';

export function profileFor(width: number, height: number): ProfileName {
  return width >= height ? 'landscape' : 'portrait';
}

export function cameraProfile(name: ProfileName): CameraProfile {
  return config.camera[name];
}
